var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"size":"small","bordered":false}},[_c('template',{slot:"title"},[_c('span',{staticStyle:{"margin-right":"4px"}},[_vm._v("任务流程使用精准测试占比")])]),_c('div',{style:({ height: _vm.height, width: _vm.width }),attrs:{"id":"wk-use-rate"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }